import React, { memo } from "react";
import parse from "html-react-parser";
import { ReactComponent as CloseIcon } from "assets/close.svg";

function TermsContent({
  title,
  content,
  onClose,
  titleStyle,
  closeTextStyle,
  closeIconStyle,
  contentContainerStyle,
}) {
  return (
    <>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          marginBottom: "10px",
        }}
      >
        <p style={titleStyle}>{title}</p>
        <button
          type="button"
          style={{
            background: "transparent",
            border: "none",
            padding: 0,
            font: "inherit",
            ...closeTextStyle,
          }}
          onClick={onClose}
        >
          <CloseIcon style={closeIconStyle} />{" "}
        </button>
      </div>
      <div style={contentContainerStyle}>{parse(content || "")}</div>
    </>
  );
}

export default memo(TermsContent);
